import { Typography, Switch } from '@web-chat-core/ui-kit';
import { Row } from './view';

type SettingsToggleRowProps = {
    label: string;
    checked: boolean;
    onChange: () => void;
    cy: string;
};

export const SettingsToggleRow = ({ label, checked, onChange, cy }: SettingsToggleRowProps) => (
    <Row>
        <Typography variant="body5">{label}</Typography>
        <Switch onChange={onChange} checked={checked} data-cy={cy} />
    </Row>
);

SettingsToggleRow.displayName = 'SettingsToggleRow';
